import React, { useEffect, useRef, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Trash2, Ban, ShieldCheck, Upload, Check, X, ShieldAlert, Copy, RefreshCw, Lock } from "lucide-react";

const TABS = [
  { key: "stats", label: "İSTATİSTİK" },
  { key: "announcements", label: "DUYURULAR" },
  { key: "tiers", label: "ÜYELİK FİYATLARI" },
  { key: "users", label: "KULLANICILAR" },
  { key: "orders", label: "BTC SİPARİŞLER" },
  { key: "data", label: "DATA YÜKLE" },
  { key: "security", label: "GÜVENLİK (2FA)" },
  { key: "settings", label: "AYARLAR" },
];

export default function Admin() {
  const [tab, setTab] = useState("stats");
  return (
    <div className="max-w-[1400px]">
      <div className="mb-6">
        <div className="gc-label mb-2">ADMİN KONSOLU</div>
        <h1 className="font-heading text-4xl md:text-5xl font-black">
          Sistem <span className="text-[#9D4EDD]">Yönetimi</span>
        </h1>
      </div>

      <div className="flex flex-wrap gap-2 mb-6 border-b border-[#141414] pb-3" data-testid="admin-tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            data-testid={`admin-tab-${t.key}`}
            className={`gc-btn-ghost ${tab === t.key ? "!border-[#9D4EDD] !text-white" : ""}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "stats" && <StatsTab />}
      {tab === "announcements" && <AnnouncementsTab />}
      {tab === "tiers" && <TiersTab />}
      {tab === "users" && <UsersTab />}
      {tab === "orders" && <OrdersTab />}
      {tab === "data" && <DataTab />}
      {tab === "security" && <SecurityTab />}
      {tab === "settings" && <SettingsTab />}
    </div>
  );
}

function StatsTab() {
  const [s, setS] = useState(null);
  useEffect(() => {
    const load = () => api.get("/admin/stats").then((r) => setS(r.data));
    load();
    const i = setInterval(load, 15000);
    return () => clearInterval(i);
  }, []);
  if (!s) return <div className="text-[#A1A1AA] font-mono text-sm">Yükleniyor…</div>;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {[
        ["Toplam Kullanıcı", s.total_users],
        ["Yasaklı", s.banned_users],
        ["Veri Kaydı", s.total_records],
        ["Toplam Sorgu", s.total_queries],
        ["Bekleyen Sipariş", s.pending_orders],
      ].map(([l, v]) => (
        <div className="gc-card p-5" key={l}>
          <div className="gc-label">{l}</div>
          <div className="font-heading text-3xl font-bold mt-2">{v}</div>
        </div>
      ))}
      <div className="gc-card p-5 col-span-2 md:col-span-4">
        <div className="gc-label mb-2">VERİ İÇE AKTARIM DURUMU</div>
        <pre className="font-mono text-xs text-[#EDEDED] whitespace-pre-wrap break-all">
{JSON.stringify(s.ingest, null, 2)}
        </pre>
      </div>
    </div>
  );
}

function AnnouncementsTab() {
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [pinned, setPinned] = useState(false);
  const [err, setErr] = useState("");
  const load = () => api.get("/announcements").then((r) => setItems(r.data.items || []));
  useEffect(() => {
    load();
  }, []);
  const create = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await api.post("/announcements", { title, body, pinned });
      setTitle("");
      setBody("");
      setPinned(false);
      load();
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail));
    }
  };
  const remove = async (id) => {
    await api.delete(`/announcements/${id}`);
    load();
  };
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <form onSubmit={create} className="gc-card p-5" data-testid="admin-ann-form">
        <div className="gc-label mb-3">YENİ DUYURU</div>
        <input
          data-testid="admin-ann-title"
          className="gc-input mb-3"
          placeholder="Başlık"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        <textarea
          data-testid="admin-ann-body"
          className="gc-input mb-3 min-h-[120px]"
          placeholder="İçerik…"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          required
        />
        <label className="flex items-center gap-2 text-sm text-[#A1A1AA] mb-3">
          <input
            data-testid="admin-ann-pinned"
            type="checkbox"
            checked={pinned}
            onChange={(e) => setPinned(e.target.checked)}
          />
          Sabitle
        </label>
        {err && <div className="text-[#9D4EDD] text-sm font-mono mb-2">{err}</div>}
        <button data-testid="admin-ann-submit" className="gc-btn-primary">YAYINLA</button>
      </form>
      <div className="space-y-3">
        {items.map((a) => (
          <div key={a.id} className="gc-card p-4 flex items-start justify-between gap-3">
            <div className="min-w-0">
              <div className="flex items-center gap-2 mb-1">
                {a.pinned && <span className="gc-badge gc-badge-red">SABİT</span>}
                <span className="text-[10px] font-mono text-[#A1A1AA]">
                  {a.created_at?.slice(0, 16).replace("T", " ")}
                </span>
              </div>
              <div className="font-heading font-bold">{a.title}</div>
              <div className="text-sm text-[#A1A1AA] whitespace-pre-wrap">{a.body}</div>
            </div>
            <button
              data-testid={`admin-ann-delete-${a.id}`}
              className="gc-btn-ghost !p-2 text-[#9D4EDD]"
              onClick={() => remove(a.id)}
            >
              <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

function TiersTab() {
  const [tiers, setTiers] = useState([]);
  const [msg, setMsg] = useState("");
  useEffect(() => {
    api.get("/tiers").then((r) => setTiers(r.data.items || []));
  }, []);
  const save = async (t) => {
    setMsg("");
    try {
      await api.put(`/tiers/${t.key}`, t);
      setMsg(`${t.name} güncellendi ✓`);
      setTimeout(() => setMsg(""), 2000);
    } catch (e) {
      setMsg(formatApiErrorDetail(e.response?.data?.detail));
    }
  };
  const update = (i, key, value) => {
    const copy = [...tiers];
    copy[i] = { ...copy[i], [key]: value };
    setTiers(copy);
  };
  return (
    <div>
      {msg && <div className="mb-3 gc-badge gc-badge-green">{msg}</div>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {tiers.map((t, i) => (
          <div key={t.key} className="gc-card p-5" data-testid={`admin-tier-${t.key}`}>
            <div className="flex items-center justify-between mb-3">
              <span className="gc-badge gc-badge-red">{t.key.toUpperCase()}</span>
            </div>
            <label className="gc-label block mb-1">İSİM</label>
            <input
              className="gc-input mb-3"
              value={t.name}
              onChange={(e) => update(i, "name", e.target.value)}
            />
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="gc-label block mb-1">GÜNLÜK LİMİT (-1 = ∞)</label>
                <input
                  data-testid={`tier-${t.key}-limit`}
                  type="number"
                  className="gc-input"
                  value={t.daily_limit}
                  onChange={(e) => update(i, "daily_limit", parseInt(e.target.value))}
                />
              </div>
              <div>
                <label className="gc-label block mb-1">FİYAT (BTC)</label>
                <input
                  data-testid={`tier-${t.key}-price`}
                  type="number"
                  step="0.00001"
                  className="gc-input"
                  value={t.price_btc}
                  onChange={(e) => update(i, "price_btc", parseFloat(e.target.value))}
                />
              </div>
              <div>
                <label className="gc-label block mb-1">SÜRE (gün)</label>
                <input
                  type="number"
                  className="gc-input"
                  value={t.duration_days}
                  onChange={(e) => update(i, "duration_days", parseInt(e.target.value))}
                />
              </div>
              <div>
                <label className="gc-label block mb-1">ÖZELLİKLER (satır satır)</label>
                <textarea
                  className="gc-input min-h-[70px]"
                  value={(t.features || []).join("\n")}
                  onChange={(e) => update(i, "features", e.target.value.split("\n").filter(Boolean))}
                />
              </div>
            </div>
            <button
              data-testid={`tier-${t.key}-save`}
              onClick={() => save(t)}
              className="gc-btn-primary mt-4 w-full"
            >
              KAYDET
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

function UsersTab() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  const [tiers, setTiers] = useState([]);
  const load = () =>
    api
      .get("/admin/users", { params: q ? { q } : {} })
      .then((r) => setUsers(r.data.items || []));
  useEffect(() => {
    load();
    api.get("/tiers").then((r) => setTiers(r.data.items || []));
  }, []);
  const ban = async (id) => {
    await api.post(`/admin/users/${id}/ban`);
    load();
  };
  const unban = async (id) => {
    await api.post(`/admin/users/${id}/unban`);
    load();
  };
  const del = async (id) => {
    if (!window.confirm("Bu kullanıcı silinsin mi?")) return;
    await api.delete(`/admin/users/${id}`);
    load();
  };
  const grant = async (user_id, tier_key, days) => {
    await api.post("/admin/users/grant", {
      user_id,
      tier_key,
      duration_days: parseInt(days) || 30,
    });
    load();
  };
  return (
    <div>
      <div className="flex gap-3 mb-4">
        <input
          data-testid="admin-users-search"
          className="gc-input"
          placeholder="Kullanıcı ara…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <button className="gc-btn-primary" onClick={load} data-testid="admin-users-search-btn">
          ARA
        </button>
      </div>
      <div className="overflow-x-auto gc-card">
        <table className="w-full text-sm">
          <thead className="text-[#A1A1AA] text-xs uppercase tracking-widest border-b border-[#141414]">
            <tr>
              <th className="text-left p-3">Kullanıcı</th>
              <th className="text-left p-3">Rol</th>
              <th className="text-left p-3">Üyelik</th>
              <th className="text-left p-3">Bitiş</th>
              <th className="text-left p-3">Sorgu</th>
              <th className="text-left p-3">Durum</th>
              <th className="text-left p-3">İşlem</th>
            </tr>
          </thead>
          <tbody className="font-mono">
            {users.map((u) => (
              <tr key={u.id} className="border-b border-[#141414]" data-testid={`user-row-${u.username}`}>
                <td className="p-3">
                  <div className="text-white">{u.username}</div>
                  <div className="text-[10px] text-[#A1A1AA]">{u.email || "-"}</div>
                </td>
                <td className="p-3">{u.role}</td>
                <td className="p-3">
                  <MembershipEditor user={u} tiers={tiers} onGrant={grant} />
                </td>
                <td className="p-3 text-xs">
                  {u.membership_expires_at?.slice(0, 10) || "-"}
                </td>
                <td className="p-3">
                  {u.queries_today || 0} / {u.total_queries || 0}
                </td>
                <td className="p-3">
                  {u.banned ? (
                    <span className="gc-badge gc-badge-red">BANLI</span>
                  ) : (
                    <span className="gc-badge gc-badge-green">AKTİF</span>
                  )}
                </td>
                <td className="p-3">
                  <div className="flex gap-2">
                    {u.role !== "admin" &&
                      (u.banned ? (
                        <button
                          data-testid={`unban-${u.username}`}
                          className="gc-btn-ghost !p-2"
                          onClick={() => unban(u.id)}
                          title="Ban kaldır"
                        >
                          <ShieldCheck size={12} />
                        </button>
                      ) : (
                        <button
                          data-testid={`ban-${u.username}`}
                          className="gc-btn-ghost !p-2"
                          onClick={() => ban(u.id)}
                          title="Banla"
                        >
                          <Ban size={12} />
                        </button>
                      ))}
                    {u.role !== "admin" && (
                      <button
                        data-testid={`delete-${u.username}`}
                        className="gc-btn-ghost !p-2 text-[#9D4EDD]"
                        onClick={() => del(u.id)}
                        title="Sil"
                      >
                        <Trash2 size={12} />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function MembershipEditor({ user, tiers, onGrant }) {
  const [k, setK] = useState(user.membership_tier || "free");
  const [d, setD] = useState(30);
  return (
    <div className="flex gap-2 items-center">
      <select
        className="gc-input !p-2 text-xs"
        value={k}
        onChange={(e) => setK(e.target.value)}
        data-testid={`tier-select-${user.username}`}
      >
        {tiers.map((t) => (
          <option key={t.key} value={t.key}>
            {t.name}
          </option>
        ))}
      </select>
      <input
        className="gc-input !p-2 text-xs w-16"
        type="number"
        value={d}
        onChange={(e) => setD(e.target.value)}
        data-testid={`days-input-${user.username}`}
      />
      <button
        data-testid={`grant-${user.username}`}
        className="gc-btn-ghost !p-2 text-xs"
        onClick={() => onGrant(user.id, k, d)}
      >
        VER
      </button>
    </div>
  );
}

function OrdersTab() {
  const [orders, setOrders] = useState([]);
  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data.items || []));
  useEffect(() => {
    load();
  }, []);
  const approve = async (id) => {
    await api.post(`/admin/orders/${id}/approve`);
    load();
  };
  const reject = async (id) => {
    await api.post(`/admin/orders/${id}/reject`);
    load();
  };
  return (
    <div className="space-y-3" data-testid="admin-orders-list">
      {orders.length === 0 && <div className="text-[#A1A1AA] text-sm">Sipariş yok.</div>}
      {orders.map((o) => (
        <div key={o.id} className="gc-card p-4 flex flex-wrap items-center justify-between gap-3">
          <div className="min-w-0">
            <div className="font-heading font-bold">
              {o.username} — {o.tier_name} ({o.price_btc} BTC)
            </div>
            <div className="text-xs font-mono text-[#A1A1AA] break-all">TX: {o.tx_id}</div>
            <div className="text-[10px] font-mono text-[#A1A1AA]">
              {o.created_at?.slice(0, 16).replace("T", " ")}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span
              className={`gc-badge ${
                o.status === "approved"
                  ? "gc-badge-green"
                  : o.status === "rejected"
                  ? "gc-badge-red"
                  : "gc-badge-gold"
              }`}
            >
              {o.status?.toUpperCase()}
            </span>
            {o.status === "pending" && (
              <>
                <button
                  data-testid={`approve-${o.id}`}
                  className="gc-btn-primary !py-2 !px-3 text-xs flex items-center gap-1"
                  onClick={() => approve(o.id)}
                >
                  <Check size={12} /> ONAY
                </button>
                <button
                  data-testid={`reject-${o.id}`}
                  className="gc-btn-ghost !py-2 !px-3 text-xs flex items-center gap-1"
                  onClick={() => reject(o.id)}
                >
                  <X size={12} /> RED
                </button>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

function DataTab() {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [platform, setPlatform] = useState("discord");
  const [pkField, setPkField] = useState("");
  const fileRef = useRef(null);

  const PLATFORMS = [
    "discord",
    "instagram",
    "snapchat",
    "tiktok",
    "facebook",
    "github",
    "telegram",
    "twitter",
  ];

  const load = () => api.get("/admin/data/status").then((r) => setStatus(r.data));
  useEffect(() => {
    load();
    const i = setInterval(load, 8000);
    return () => clearInterval(i);
  }, []);

  const upload = async (file) => {
    if (!file) return;
    setMsg("");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const params = new URLSearchParams({ platform });
      if (pkField) params.append("primary_key_field", pkField);
      const { data } = await api.post(`/admin/data/upload?${params.toString()}`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMsg(`Yükleme başladı: ${data.filename} → ${data.platform} (${data.size} bayt). İşleniyor…`);
    } catch (e) {
      setMsg(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
      load();
    }
  };

  return (
    <div className="space-y-4">
      <div className="gc-card p-4">
        <div className="gc-label mb-3">YÜKLEME AYARLARI</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="gc-label block mb-1.5">PLATFORM</label>
            <select
              data-testid="admin-upload-platform"
              className="gc-input"
              value={platform}
              onChange={(e) => setPlatform(e.target.value)}
            >
              {PLATFORMS.map((p) => (
                <option key={p} value={p}>
                  {p.charAt(0).toUpperCase() + p.slice(1)}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="gc-label block mb-1.5">
              PRIMARY KEY ALAN (opsiyonel — JSON/SQL için)
            </label>
            <input
              data-testid="admin-upload-pk"
              className="gc-input"
              placeholder="Örn: username, user_id, id"
              value={pkField}
              onChange={(e) => setPkField(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div
        className="gc-card p-8 border-dashed border-[#333] text-center hover:border-[#9D4EDD] transition-colors cursor-pointer"
        onClick={() => fileRef.current?.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault();
          if (e.dataTransfer.files?.[0]) upload(e.dataTransfer.files[0]);
        }}
        data-testid="admin-upload-zone"
      >
        <Upload className="mx-auto text-[#9D4EDD] mb-3" size={26} />
        <div className="font-heading text-lg font-bold">Data Dosyası Yükle</div>
        <div className="text-xs text-[#A1A1AA] mt-1">
          Desteklenen formatlar: .sql / .x (MySQL dump) · .json (array veya NDJSON) · .txt (satır satır)
        </div>
        <div className="text-[10px] text-[#525252] mt-2 font-mono uppercase tracking-widest">
          Hedef platform: {platform}
        </div>
        <input
          ref={fileRef}
          type="file"
          className="hidden"
          data-testid="admin-upload-input"
          accept=".sql,.x,.txt,.json,application/json,application/octet-stream,text/plain"
          onChange={(e) => upload(e.target.files?.[0])}
        />
        {busy && <div className="mt-4 text-xs font-mono text-[#EAB308]">Yükleniyor…</div>}
        {msg && <div className="mt-4 text-xs font-mono text-[#00FF66]">{msg}</div>}
      </div>

      {status && (
        <div className="gc-card p-5">
          <div className="gc-label mb-2">PLATFORM BAŞINA KAYIT</div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
            {Object.entries(status.per_platform || {}).map(([p, c]) => (
              <div key={p} className="border border-[#141414] p-3 rounded-lg">
                <div className="text-[10px] font-mono tracking-widest text-[#A1A1AA] uppercase">
                  {p}
                </div>
                <div className="font-heading text-2xl font-bold mt-1">
                  {Number(c).toLocaleString("tr-TR")}
                </div>
              </div>
            ))}
          </div>
          <div className="gc-label mb-2">SON İŞLEM DURUMU</div>
          <pre className="font-mono text-[11px] text-[#A1A1AA] whitespace-pre-wrap bg-[#050505] p-3 border border-[#141414] rounded-lg">
{JSON.stringify(status.ingest, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}

function SettingsTab() {
  const [btc, setBtc] = useState("");
  const [notice, setNotice] = useState("");
  const [fakeUsers, setFakeUsers] = useState(0);
  const [fakeQueries, setFakeQueries] = useState(0);
  const [msg, setMsg] = useState("");
  useEffect(() => {
    api.get("/admin/settings").then((r) => {
      setBtc(r.data.btc_address || "");
      setNotice(r.data.site_notice || "");
      setFakeUsers(r.data.fake_users_offset ?? 0);
      setFakeQueries(r.data.fake_queries_offset ?? 0);
    });
  }, []);
  const save = async () => {
    setMsg("");
    try {
      await api.put("/admin/settings", {
        btc_address: btc,
        site_notice: notice,
        fake_users_offset: fakeUsers,
        fake_queries_offset: fakeQueries,
      });
      setMsg("Kaydedildi ✓");
      setTimeout(() => setMsg(""), 1500);
    } catch (e) {
      setMsg(formatApiErrorDetail(e.response?.data?.detail));
    }
  };
  return (
    <div className="gc-card p-5 max-w-2xl">
      <label className="gc-label block mb-2">BTC ADRESİ</label>
      <input
        data-testid="admin-btc-input"
        className="gc-input mb-4"
        value={btc}
        onChange={(e) => setBtc(e.target.value)}
      />
      <label className="gc-label block mb-2">SİTE NOTU</label>
      <textarea
        data-testid="admin-notice-input"
        className="gc-input mb-4 min-h-[100px]"
        value={notice}
        onChange={(e) => setNotice(e.target.value)}
      />
      <div className="border-t border-[#141414] my-4 pt-4">
        <div className="gc-label mb-3">BALON İSTATİSTİKLER (marketing)</div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="gc-label block mb-1.5">Toplam kullanıcıya eklenecek</label>
            <input
              data-testid="admin-fake-users"
              className="gc-input"
              type="number"
              min={0}
              value={fakeUsers}
              onChange={(e) => setFakeUsers(parseInt(e.target.value || "0"))}
            />
          </div>
          <div>
            <label className="gc-label block mb-1.5">Toplam sorguya eklenecek</label>
            <input
              data-testid="admin-fake-queries"
              className="gc-input"
              type="number"
              min={0}
              value={fakeQueries}
              onChange={(e) => setFakeQueries(parseInt(e.target.value || "0"))}
            />
          </div>
        </div>
        <div className="text-[10px] font-mono text-[#525252] mt-2">
          Dashboard'da gösterilen "TOPLAM KULLANICI" ve "TOPLAM SORGU" değerlerine bu ofset eklenir.
        </div>
      </div>
      {msg && <div className="text-[#00FF66] text-sm font-mono mb-2">{msg}</div>}
      <button data-testid="admin-settings-save" className="gc-btn-primary" onClick={save}>
        KAYDET
      </button>
    </div>
  );
}

function SecurityTab() {
  const [status, setStatus] = useState(null); // {enabled, has_pending_setup, backup_codes_remaining}
  const [setup, setSetup] = useState(null); // {secret, otpauth_uri, qr_code_data_url}
  const [verifyCode, setVerifyCode] = useState("");
  const [backupCodes, setBackupCodes] = useState(null);
  const [disablePwd, setDisablePwd] = useState("");
  const [disableCode, setDisableCode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const loadStatus = async () => {
    try {
      const { data } = await api.get("/auth/2fa/status");
      setStatus(data);
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  useEffect(() => {
    loadStatus();
  }, []);

  const startSetup = async () => {
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/2fa/setup");
      setSetup(data);
      setVerifyCode("");
      setBackupCodes(null);
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const confirmSetup = async () => {
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/2fa/verify", { code: verifyCode });
      setBackupCodes(data.backup_codes);
      setSetup(null);
      await loadStatus();
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const disable2fa = async () => {
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/2fa/disable", { password: disablePwd, code: disableCode });
      setDisablePwd("");
      setDisableCode("");
      setBackupCodes(null);
      await loadStatus();
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const regenBackups = async () => {
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/2fa/backup-codes/regenerate", { code: verifyCode });
      setBackupCodes(data.backup_codes);
      setVerifyCode("");
      await loadStatus();
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  if (!status) {
    return <div className="text-sm font-mono text-[#A1A1AA]">Yükleniyor…</div>;
  }

  return (
    <div className="max-w-3xl space-y-4">
      <div className="gc-card p-5">
        <div className="flex items-center gap-2 mb-2">
          <ShieldAlert size={18} className="text-[#9D4EDD]" />
          <div className="font-heading text-xl font-bold">İki Faktörlü Doğrulama</div>
        </div>
        <p className="text-sm text-[#A1A1AA]">
          Admin hesabınızı Authy / Google Authenticator ile koruyun. Aktifken her girişte 6 haneli
          kod istenir. Kaybolan telefon durumunda tek kullanımlık yedek kodlarla girebilirsiniz.
        </p>

        <div className="mt-4 flex items-center gap-3 text-sm">
          <span
            data-testid="twofa-status-badge"
            className={`px-2 py-1 font-mono text-[10px] tracking-widest rounded ${
              status.enabled
                ? "text-[#00FF66] border border-[#00FF66]/40 bg-[#00FF66]/5"
                : "text-[#9D4EDD] border border-[#9D4EDD]/40 bg-[#9D4EDD]/5"
            }`}
          >
            {status.enabled ? "AKTİF" : "KAPALI"}
          </span>
          {status.enabled && (
            <span className="font-mono text-[10px] text-[#A1A1AA]">
              Kalan yedek kod: {status.backup_codes_remaining}
            </span>
          )}
        </div>
      </div>

      {error && (
        <div className="text-[#9D4EDD] text-sm font-mono border border-[#9D4EDD]/40 bg-[#9D4EDD]/5 p-3 rounded">
          {error}
        </div>
      )}

      {/* Not enabled — Start setup */}
      {!status.enabled && !setup && !backupCodes && (
        <div className="gc-card p-5">
          <div className="gc-label mb-3">KURULUM</div>
          <p className="text-sm text-[#A1A1AA] mb-4">
            &quot;Kurulumu Başlat&quot; butonuna bas, QR kodu Authy uygulamasında tara ve gelen kodu gir.
          </p>
          <button
            data-testid="twofa-start"
            onClick={startSetup}
            disabled={busy}
            className="gc-btn-primary"
          >
            {busy ? "OLUŞTURULUYOR…" : "KURULUMU BAŞLAT"}
          </button>
        </div>
      )}

      {/* Setup in progress: QR + verify */}
      {setup && (
        <div className="gc-card p-5">
          <div className="gc-label mb-3">1) QR KODUNU TARA</div>
          <div className="flex flex-col md:flex-row gap-6 items-start">
            <img
              src={setup.qr_code_data_url}
              alt="2FA QR"
              className="w-52 h-52 bg-white p-2 rounded-lg"
              data-testid="twofa-qr"
            />
            <div className="flex-1">
              <div className="text-xs text-[#A1A1AA] mb-2">
                Uygulaman QR desteklemiyorsa aşağıdaki gizli anahtarı manuel gir:
              </div>
              <div className="flex items-center gap-2">
                <code
                  className="font-mono text-xs bg-[#050505] border border-[#141414] px-3 py-2 rounded flex-1 break-all"
                  data-testid="twofa-secret"
                >
                  {setup.secret}
                </code>
                <button
                  className="gc-btn-ghost !px-2 !py-2"
                  onClick={() => navigator.clipboard.writeText(setup.secret)}
                  title="Kopyala"
                >
                  <Copy size={14} />
                </button>
              </div>

              <div className="gc-label mt-6 mb-2">2) UYGULAMADAKİ 6 HANELİ KODU GİR</div>
              <input
                data-testid="twofa-verify-input"
                className="gc-input mb-3 font-mono text-center tracking-[0.4em] text-lg"
                placeholder="123 456"
                value={verifyCode}
                onChange={(e) => setVerifyCode(e.target.value.replace(/[^0-9]/g, ""))}
                maxLength={6}
                inputMode="numeric"
              />
              <div className="flex gap-2">
                <button
                  data-testid="twofa-confirm"
                  onClick={confirmSetup}
                  disabled={busy || verifyCode.length < 6}
                  className="gc-btn-primary"
                >
                  {busy ? "DOĞRULANIYOR…" : "AKTİFLEŞTİR"}
                </button>
                <button
                  className="gc-btn-ghost"
                  onClick={() => {
                    setSetup(null);
                    setVerifyCode("");
                    setError("");
                  }}
                >
                  İPTAL
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Backup codes just generated */}
      {backupCodes && (
        <div className="gc-card p-5 border-[#9D4EDD]/40">
          <div className="flex items-center gap-2 mb-2 text-[#9D4EDD]">
            <Lock size={16} />
            <div className="font-heading font-bold">YEDEK KODLARINIZ (bir daha gösterilmeyecek)</div>
          </div>
          <p className="text-xs text-[#A1A1AA] mb-3">
            Telefonunu kaybedersen bu kodların her biri bir defaya mahsus giriş yapmanı sağlar.
            Şifre yöneticine ya da güvenli bir yere kaydet.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-3">
            {backupCodes.map((c) => (
              <code
                key={c}
                data-testid="twofa-backup-code"
                className="font-mono text-sm text-[#EDEDED] bg-[#050505] border border-[#141414] px-2 py-2 rounded text-center"
              >
                {c}
              </code>
            ))}
          </div>
          <button
            className="gc-btn-ghost inline-flex items-center gap-2"
            onClick={() => {
              navigator.clipboard.writeText(backupCodes.join("\n"));
            }}
          >
            <Copy size={12} /> HEPSİNİ KOPYALA
          </button>
        </div>
      )}

      {/* Enabled — regenerate + disable */}
      {status.enabled && (
        <>
          <div className="gc-card p-5">
            <div className="gc-label mb-2">YEDEK KODLARI YENİLE</div>
            <p className="text-xs text-[#A1A1AA] mb-3">
              Eski yedek kodlar geçersiz kılınır, 8 yeni kod verilir. Uygulamadan güncel kodu gir.
            </p>
            <div className="flex gap-2">
              <input
                data-testid="twofa-regen-code"
                className="gc-input font-mono text-center tracking-[0.4em]"
                placeholder="6 haneli kod"
                value={verifyCode}
                onChange={(e) => setVerifyCode(e.target.value.replace(/[^0-9]/g, ""))}
                maxLength={6}
              />
              <button
                onClick={regenBackups}
                disabled={busy || verifyCode.length < 6}
                className="gc-btn-ghost inline-flex items-center gap-2 shrink-0"
                data-testid="twofa-regen"
              >
                <RefreshCw size={14} /> YENİLE
              </button>
            </div>
          </div>

          <div className="gc-card p-5 border-[#9D4EDD]/30">
            <div className="gc-label mb-2 text-[#9D4EDD]">2FA&apos;YI KAPAT</div>
            <p className="text-xs text-[#A1A1AA] mb-3">
              Şifreni ve güncel 6 haneli kodu (veya yedek kodu) girmen gerekir.
            </p>
            <input
              type="password"
              data-testid="twofa-disable-password"
              className="gc-input mb-2"
              placeholder="Şifre"
              value={disablePwd}
              onChange={(e) => setDisablePwd(e.target.value)}
            />
            <input
              data-testid="twofa-disable-code"
              className="gc-input mb-3 font-mono text-center tracking-[0.4em]"
              placeholder="6 haneli kod veya yedek kod"
              value={disableCode}
              onChange={(e) => setDisableCode(e.target.value)}
              maxLength={10}
            />
            <button
              data-testid="twofa-disable"
              onClick={disable2fa}
              disabled={busy || !disablePwd || disableCode.length < 6}
              className="gc-btn-primary !bg-[#9D4EDD]"
            >
              {busy ? "KAPATILIYOR…" : "2FA'YI DEVRE DIŞI BIRAK"}
            </button>
          </div>
        </>
      )}
    </div>
  );
}

